<template>
  <div class="banner-row row">
    <div class="banner-row-body col-12">
      <div class="row">
        <slot></slot>
      </div>
    </div>
  </div>
</template>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
$radius: 50px;
.banner-row {
  .banner-row-body {
    background-color: #ffbe17;
    border-radius: 0 $radius $radius 0;
    // min-height: 100px;
    overflow: hidden;
  }
}
</style>


<script>
export default {
  name: "BannerRow",
  props: {}
};
</script>